import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import {Get,Post,Put,Delete} from "@/request/index.js"
import storage from '@/utils/storage'
import api from "@/request/api"
import elementUi from './assets/js/element-ui'
import axios from 'axios'
import md5 from 'js-md5';
import xh from "@/utils/media.xinhuamm.net_js_xinhua-sdk_xinhua-sdk"

// 引入 VConsole
// import VConsole from 'vconsole'
import "@/router/permission"
import "@/assets/js/vant"
import 'lib-flexible'; 
import 'element-ui/lib/theme-chalk/index.css';
import "@/icons"
Vue.use(elementUi)



// css
import "@/assets/css/reset.css"
import "@/assets/css/com.css"
import "@/assets/css/root.css"
import "@/icons"

Vue.config.productionTip = false
Vue.prototype.$get = Get
Vue.prototype.$post = Post
Vue.prototype.$put = Put
Vue.prototype.$delete = Delete
Vue.prototype.$api = api
Vue.prototype.$storage = storage
Vue.prototype.$axios = axios
Vue.prototype.$md5 = md5;
Vue.prototype.$xh = xh;


//当访问路径包含"H5VconsoleDebugging" 参数的时候显示Vconsole
// if(window.location.pathname.includes('H5VconsoleDebugging')) {
//   new VConsole() // 初始化
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



